import { SVGProps } from 'react'

export const DEIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16816_21564)">
      <path
        d="M1.49268 32.3496C4.88371 41.4887 13.6807 48.0018 23.9999 48.0018C34.319 48.0018 43.1161 41.4887 46.5071 32.3496L23.9999 30.2627L1.49268 32.3496Z"
        fill="#FFDA44"
      />
      <path
        d="M23.9999 0.00146484C13.6807 0.00146484 4.88371 6.51446 1.49268 15.6537L23.9999 17.7406L46.5071 15.6536C43.1161 6.51446 34.319 0.00146484 23.9999 0.00146484Z"
        fill="black"
      />
      <path
        d="M1.49278 15.6514C0.528094 18.2513 0 21.0635 0 23.9991C0 26.9348 0.528094 29.747 1.49278 32.3469H46.5073C47.472 29.747 48 26.9348 48 23.9991C48 21.0635 47.472 18.2513 46.5072 15.6514H1.49278Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_16816_21564">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
